// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-override---2Hu5_>div{display:-webkit-box;display:-ms-flexbox;display:flex;max-width:260px !important;padding:30px 40px 5px}.modal-override---2Hu5_ [class*=\"ButtonContainer\"]{margin-top:10px}\n", ""]);
// Exports
exports.locals = {
	"modal-override": "modal-override---2Hu5_"
};
module.exports = exports;
